import CGUDO from './helpers/CGUDO';
import paths from './helpers/paths';
import { dbCollection } from './helpers/utils';
export const waitlist = (params) => (docId) => CGUDO(params)(paths.waitlists(docId));
export const waitlists = dbCollection(paths.waitlists());
